import { Box, Button, Typography } from '@mui/material';

import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';

type PendingActivityConflictDialogProps = {
  open: boolean;
  actionLabel: string;
  parentType?: 'Lead' | 'Lot' | 'BuyerLead' | 'User' | 'Enquiry' | null;
  onClose: () => void;
  onConfirmCreateNew: () => void;
  onConfirmUpdateExisting: () => void;
};

export const PendingActivityConflictDialog = ({
  open,
  actionLabel,
  parentType,
  onClose,
  onConfirmCreateNew,
  onConfirmUpdateExisting,
}: PendingActivityConflictDialogProps) => {
  const { t } = useLocale();
  const actionLower = actionLabel.toLowerCase();

  const title =
    parentType === 'Lot'
      ? t('A {{activity}} is pending on this listing', {
          activity: actionLower,
        })
      : parentType === 'BuyerLead'
      ? t('A {{activity}} is pending on this buyer lead', {
          activity: actionLower,
        })
      : t('A {{activity}} is pending on this lead', {
          activity: actionLower,
        });

  const handleCreate = () => {
    onConfirmCreateNew();
    onClose();
  };

  const handleUpdate = () => {
    onConfirmUpdateExisting();
    onClose();
  };

  return (
    <SlideDialog
      open={open}
      onClose={onClose}
      title={title}
      onSave={handleUpdate}
      saveIcon={null}
      saveText={t('Update')}
      secondaryActions={
        <Button onClick={handleCreate} variant="text">
          {t('Create')}
        </Button>
      }
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body1">
          {t('Are you sure you want to create a new {{activity}}?', {
            activity: actionLower,
          })}
        </Typography>
      </Box>
    </SlideDialog>
  );
};
